module.exports = __webpack_public_path__ + "img/BUCK-SLIDER-04.baf48a90.jpg";